module.exports = __webpack_public_path__ + "img/fd1021d.svg";